export default {"src":"/_next/static/media/01_Telegram_EN.9b3388a7.gif","height":261,"width":267};